import {TCurrency, TFilter, TResponse, TUUID} from '@/types';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequestAdmin} from '../../../../api/ws';
import {
  TNium,
  TPaymentInfo,
} from './types';
import {
  getNium,
  getPaymentInfo,
} from './mock';
import {
  Nium,
  TGroup, TGroupType,
} from '../types';
import {
  getGroupList,
} from '../mock';
import faker from '@faker-js/faker';
import {GROUP_TYPE_NIUM, GROUP_TYPE_VERTO} from '../constants';

import {
  ENDPOINT_ADMIN_PO_NIUM_LIST,
  ENDPOINT_ADMIN_PO_NIUM_DETAILS,
  ENDPOINT_ADMIN_PO_NIUM_CREATE,
  ENDPOINT_ADMIN_PO_NIUM_UPDATE,
  ENDPOINT_ADMIN_PO_NIUM_DIRECT,
  ENDPOINT_ADMIN_PO_NIUM_REFRESH
} from '../../../../constants/api';

type TPayoutStartParams = {ids: TUUID[], fiat_code: TCurrency, system: string};

// Возвращает информацию по конкретной выплате
export function apiAdminPayoutNiumGet(params: {payout_id: TUUID}): Promise<TNium> {
  const url = ENDPOINT_ADMIN_PO_NIUM_DETAILS;
  if (process.env.MOCK) {
    const response = getNium(faker.finance.currencyCode());
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

// Создаёт новую группу для выплат через Nium
export function apiAdminPayoutNiumGroupCreate(params: TPayoutStartParams): Promise<TGroup<Nium>[]> {
  const url = ENDPOINT_ADMIN_PO_NIUM_CREATE;

  if (process.env.MOCK) {
    const limit = faker.mersenne.rand(5);
    const response = getGroupList([GROUP_TYPE_NIUM], limit);
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

// Добавляет транзакцию Nium -> Merchant проведённую вне процессинга
export function apiAdminPayoutNiumManualUpdate(params: Partial<TPaymentInfo>): Promise<TResponse> {
  const url = ENDPOINT_ADMIN_PO_NIUM_UPDATE;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}

// Стартует перевод Nium -> Merchant
export function apiAdminPayoutNiumStartDirect(params: {payout_id: TUUID}): Promise<TPaymentInfo> {
  const url = ENDPOINT_ADMIN_PO_NIUM_DIRECT;
  if (process.env.MOCK) {
    const response = getPaymentInfo();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

// Обновляет статус перевода Nium -> Merchant
export function apiAdminPayoutNiumManualRefreshTransaction(params: {payout_id: TUUID}): Promise<TPaymentInfo> {
  const url = ENDPOINT_ADMIN_PO_NIUM_REFRESH;
  if (process.env.MOCK) {
    const response = getPaymentInfo();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

// Получить список платежей Nium
export function apiAdminPayoutGroupList(params: TFilter<TGroup<TGroupType>>): Promise<TGroup<TGroupType>[]> {
  const url = ENDPOINT_ADMIN_PO_NIUM_LIST;
  params = params || {};
  params.offset = params.offset || 0;
  params.limit = params.limit || 50;

  if (process.env.MOCK) {
    const response = {
      list: getGroupList([
        GROUP_TYPE_NIUM,
        GROUP_TYPE_VERTO,
      ], params.limit),
      count: params.limit * 10,
    };
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return apiRequestAdmin(url, params);
}
